// extracted by mini-css-extract-plugin
export default {"error":"error__9hV64","icon":"icon__uI3yr","title":"title__-5gNx","subtitle":"subtitle__45+zY"};